import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loadingoverlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"text-align":"center"}
}, "Loading...", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle",
  style: {"text-align":"center"}
}, " Hang tight, this will just take a sec. ", -1)
const _hoisted_13 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLoader',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  isFullPage: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("img", {
          src: require('@/assets/images/loading.gif'),
          alt: "Loading"
        }, null, 8, _hoisted_13)
      ]))
    : _createCommentVNode("", true)
}
}

})